/**
 * Хлебные крошки страницы в разметке schema.org.
 *
 * Отдельным <script type="application/ld+json">, а не внутри общего @graph
 * лейаута: граф собирается один раз на весь сайт, а крошки у каждой страницы
 * свои. Складывать их в общий узел значило бы дёргать лейаут из каждой
 * страницы — ровно та связанность, от которой SEO-разметку недавно избавили.
 *
 * Ключ ld-json-breadcrumbs обязателен: без него unhead считает два JSON-LD
 * разными скриптами и при переходе между страницами на клиенте крошки
 * предыдущей остаются в <head>.
 */
import { buildBreadcrumbs, graphToJson, type BreadcrumbItem } from './structuredData'

export function useBreadcrumbsJsonLd(items: () => BreadcrumbItem[]): void {
  const url = useRequestURL({ xForwardedHost: true, xForwardedProto: true })

  useHead(() => {
    const node = buildBreadcrumbs(url.origin, items())
    const json = node ? graphToJson([node]) : ''

    return {
      script: json
        ? [{ type: 'application/ld+json', innerHTML: json, key: 'ld-json-breadcrumbs' }]
        : [],
    }
  })
}
